
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[website]/contact",
      function () {
        return require("private-next-pages/[website]/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[website]/contact"])
      });
    }
  